import styled from 'styled-components';

import { breakpoints, colors, fontFamily, functions } from '../../ui/variables';

export const ExamResumeCardStyle = styled.div`
  background-color: ${colors.mostlyWhite};
  border-radius: 20px;
  box-shadow: 0 3px 20px ${functions.rgba(colors.grayishBlue, 0.25)};
  padding: 16px 20px 32px;
  width: 100%;

  @media (min-width: ${breakpoints.hd.width}px) {
    box-shadow: none;
    height: 100%;
  }

  .exam-resume-card-title {
    ${fontFamily.sourceSansPro.bold};
    color: ${colors.veryDarkGrayishBlue};
    font-size: 14px;
    line-height: 18px;
    margin-bottom: 32px;
  }

  .time-course-control {
    display: flex;
    justify-content: space-between;
    margin-bottom: 32px;

    .time-course-button {
      ${fontFamily.sourceSansPro.regular};
      color: ${functions.flattened(
        colors.veryDarkGrayishBlue,
        colors.white,
        0.25
      )};
      flex-basis: 33.33%;
      font-size: 14px;
      line-height: 18px;
      transition: color 300ms;

      &:nth-child(3n + 1) {
        text-align: left;
      }

      &:nth-child(3n + 2) {
        text-align: center;
      }

      &:nth-child(3n + 3) {
        text-align: right;
      }

      &.selected {
        color: ${colors.veryDarkGrayishBlue};
      }
    }
  }

  .exam-resume-value {
    ${fontFamily.sourceSansPro.bold};
    color: ${colors.veryDarkGrayishBlue};
    font-size: 52px;
    line-height: 64px;
  }
`;
